// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__i9Wfr","content":"LoadingAlert_content__hOA7p"};